import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import VouchersList from "./GamesList";

export const games = {
  list: VouchersList,
  icon: SportsEsportsIcon,
  options: { label: "Jeux" },
};
